import { render, staticRenderFns } from "./GerenciaCadastroMatriculas.vue?vue&type=template&id=3abbd38d"
import script from "./GerenciaCadastroMatriculas.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroMatriculas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports